/*----------------------------------------------------------------------------------------------
 *  Archivo que maneja fetch para todos los requerimientos de solicitud
 *  de datos al servidor
 -----------------------------------------------------------------------------------------------*/

/*
 *  Esta función recibe los siguientes datos:
 *      - un objeto con:
 *          - url: dirección completa que incluye direccion y slashes (Ej: "http://cerberusb.camtor.net:5005/user/login")
 *          - method:   el metodo a utilizarse.  Por default es 'POST' porque se utiliza más que los otros. Pueden ser: GET, PUT, etc.
 *          - token:    el token del usuario, default '' (vacio). El token es un string generado al incio de la sesión que permite
 *                      verificar que usuario está interactuando con el servidor y si la sesión es válida.
 *          - body:     el cuerpo del mensaje, por defecto null.  Es un objeto con todos los datos que se desea enviar al servidor.
 *      - dispatch: funcion dispatch, para actualizar datos mediante el ContextProvider (useContext/reducer)
 * 
 *      - Ejemplo de uso: const data = await fetchData({ url: url + '/login', body: user }, dispatch);
 */ 
const fetchData = async ({url, method='POST', token='', body=null}, dispatch) => {
    //('fetchData: ', {url, method, token, body});
    //En el header se incluye authorization sólo si se recibe token, de lo contario sólo se envia el content-type
    const headers = token ? { 'content-type':'application/json', authorization: `Bearer ${token}`}
                    : { 'content-type':'application/json', authorization: `Bearer ${token}`}
    //El body se envía al servidor stringifyed si existe, de lo contrario se envía un objeto nulo
    body = body ? {body: JSON.stringify(body)} : {};
    //console.log({body})
    try {
        const response = await fetch(url, {method, headers, ...body});
        //console.log({response});
        const data = await response.json();
        //console.log({data});
        if(!data.success){
            //console.log('Función fechData: error data: ', data);
            //Verifica si el motivo de no success es por usuario no autorizado, de ser así, lo desloguea
            if(response.status === 400) {
                dispatch({type: 'UPDATE_USER', payload: null});
                return data;
            }
            if(response.status === 401) {
                dispatch({type: 'UPDATE_USER', payload: null});
                throw new Error(data.message);
            }
            if(response.status === 404) {
                dispatch({type: 'UPDATE_USER', payload: null});
                return data;
            }
            if(response.status === 500) {
                //console.log('Error 500: ', data.message);
                throw new Error(data.message);
            }
            throw new Error(data.message);
        }
        //console.log('respuesta: ', data.result);
        //return data.result; //Se devuelven los resultados en caso de éxito
        return data; //Se devuelven los resultados en caso de éxito
    } catch (error) {
        dispatch({type: 'UPDATE_ALERT', payload: {open: true, severity: 'error', message: error.message}});
        //console.log(error);
        return {success: false, error: error.message};    //Se devuelve nulo en caso de error
    }
}

export const fetchDataV2 = async ({url, method='POST', token='', body=null}) => {
    //console.log('fetchData: ', {url, method, token, body});
    //En el header se incluye authorization sólo si se recibe token, de lo contario sólo se envia el content-type
    const headers = token ? { 'content-type':'application/json', authorization: `Bearer ${token}`}
                    : { 'content-type':'application/json'}
    //El body se envía al servidor stringifyed si existe, de lo contrario se envía un objeto nulo
    body = body ? {body: JSON.stringify(body)} : {};
    const response = await fetch(url, {method, headers, ...body});      //los "..." en "...body" son necesarios porque el body se lo ha creado como un objeto {body: 'jsonString'}

    if(!response.ok) {
        if(response.status === 401) {
            throw new Error("Error 401");
        }
        if(response.status === 500) {
            throw new Error("Error 500");
        }
        throw new Error("Error desconocido");
    } 

    return response.json();
}

export default fetchData;